import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {WaitlistItemModel} from './WaitlistItem.model';

@injectable()
export class WaitlistItemFactory
  implements BaseDomainFactory<WaitlistItemModel, WaitlistItemModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: WaitlistItemModel.Props): WaitlistItemModel {
    return this.modelsRegistry.put(new WaitlistItemModel(props));
  }
}
